/**
 * The hub-level (Ordway-aware) trial flag, shared by the plan-action CTA branch and the
 * credit-purchase gating. Ordway accounts are "in trial" only before checkout is pending; other
 * accounts are also treated as trial while on a Journeys-trial-on-Pipelines plan (messaging enabled
 * with an expiry). Ports the Ember `current-plans` `isTrial` getter.
 */
export function deriveIsTrial(args: {
  ordwayId?: string;
  isBillingTrial: boolean;
  isPendingCheckout: boolean;
  messagingEnabled: boolean;
  messagingExpiresAt: number | null;
}): boolean {
  const isOrdwayCustomer = args.ordwayId != null && args.ordwayId.length > 0;
  if (isOrdwayCustomer) {
    return args.isBillingTrial && !args.isPendingCheckout;
  }
  const isJourneysTrialOnPipelinesPlan = args.messagingEnabled && args.messagingExpiresAt != null;
  return args.isBillingTrial || isJourneysTrialOnPipelinesPlan;
}
